import { useLocation as useRouterLocation } from 'react-router-dom';

import { LocationState } from 'src/types/routes.types';

export const useLocation = () => useRouterLocation<LocationState>();
